import { Box, Button, Stack, Typography } from '@mui/material';
import { ContentBox } from '@/components/shared/content-box';
import type { Lesson } from '@/data/corporate-university/interfaces';
import { useLessons } from '@/packages/corporate-university/context/lessons';
import { useGenerateCertificate } from '@/packages/corporate-university/hooks';
import { LessonItem } from '@/packages/corporate-university/pages/course-by-id/components/lesson-item';

export const LessonsList = () => {
  const { course, setCurrentLesson, isCourseCompleted } = useLessons();
  const { viewCertificate, loadingCertificate } = useGenerateCertificate(
    course?.id ?? ''
  );
  return (
    <ContentBox height="560px" spacing={2}>
      <Typography variant="h2">{course?.name}</Typography>
      {isCourseCompleted && (
        <Button
          variant="contained"
          onClick={viewCertificate}
          loading={loadingCertificate}
        >
          {loadingCertificate ? 'Gerando certificado...' : 'Ver certificado'}
        </Button>
      )}
      <Box>
        <Typography variant="h3">Aulas</Typography>

        <Stack sx={{ overflow: 'auto', height: '400px' }}>
          {course?.lessons?.map((lesson: Lesson) => (
            <Box key={lesson.id}>
              <LessonItem
                key={lesson.id}
                lesson={lesson}
                isCurrent={
                  course?.courses_progresses?.[0]?.current_lesson === lesson.id
                }
                onClick={() => setCurrentLesson(lesson)}
              />
            </Box>
          ))}
        </Stack>
      </Box>
    </ContentBox>
  );
};
